import {
  GetResultCookieParametersType,
  IExternalVisitorCodeManager,
  SetDataParametersType,
} from './types';
import { CookieParameter } from './constants';
import {
  KameleoonLogger,
  KameleoonUtils,
} from '@kameleoon/javascript-sdk-core/browser';

class VisitorCodeManager implements IExternalVisitorCodeManager {
  public getData(key: string): string | null {
    KameleoonLogger.debug`CALL: VisitorCodeManager.getData(key: ${key})`;
    const cookie = document.cookie;

    let visitorCode = null;
    if (cookie) {
      visitorCode = KameleoonUtils.getCookieValue(cookie, key);
    }

    KameleoonLogger.debug`RETURN: VisitorCodeManager.getData(key: ${key}) -> (visitorCode: ${visitorCode})`;
    return visitorCode;
  }

  public setData({
    visitorCode,
    domain,
    maxAge,
    key,
    path,
  }: SetDataParametersType): void {
    const resultCookie = this.getResultCookie({
      domain,
      visitorCode,
      key,
      maxAge,
      path,
    });

    document.cookie = resultCookie;
    KameleoonLogger.debug`Cookie ${resultCookie} was added for visitor ${visitorCode}`;
  }

  private getResultCookie({
    domain,
    visitorCode,
    maxAge,
    key,
    path,
  }: GetResultCookieParametersType): string {
    const cookieArray = [
      key + CookieParameter.KeyValueDelimiter + visitorCode,
      CookieParameter.MaxAge + CookieParameter.KeyValueDelimiter + maxAge,
      CookieParameter.Path + CookieParameter.KeyValueDelimiter + path,
    ];

    if (domain) {
      cookieArray.push(
        CookieParameter.Domain + CookieParameter.KeyValueDelimiter + domain,
      );
    }

    return cookieArray.join(CookieParameter.PairsDelimiter);
  }
}

export { VisitorCodeManager as KameleoonVisitorCodeManager };
